import { Stage } from '../../lib/types/stageIndicator';

export const stages: Stage[] = [
  {
    index: 0,
    title: 'Rooms',
    label: 'Rooms',
    loadAnimation: false,
  },
  {
    index: 1,
    title: 'Traveller',
    label: 'Traveller',
    loadAnimation: false,
  },
  {
    index: 2,
    title: 'Payment',
    label: 'Confirmation',
    loadAnimation: true,
  },
];

// DealsAway asks for traveller details before rooms.
export const dealsAwayStages: Stage[] = [
  {
    index: 0,
    title: 'Traveller',
    label: 'Traveller',
    loadAnimation: false,
  },
  {
    index: 1,
    title: 'Rooms',
    label: 'Rooms',
    loadAnimation: false,
  },
  {
    index: 2,
    title: 'Payment',
    label: 'Confirmation',
    loadAnimation: true,
  },
];

export const getStages = (isDA: boolean): Stage[] =>
  isDA ? dealsAwayStages : stages;
